import script from "./Newsletter-post-detail-item.vue?vue&type=script&setup=true&lang=js"
export * from "./Newsletter-post-detail-item.vue?vue&type=script&setup=true&lang=js"

import "./Newsletter-post-detail-item.vue?vue&type=style&index=0&id=6211c4ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6211c4ed"]])

export default __exports__